import { render, staticRenderFns } from "./game-pc-top.vue?vue&type=template&id=07c07cca&scoped=true"
import script from "./game-pc-top.vue?vue&type=script&lang=js"
export * from "./game-pc-top.vue?vue&type=script&lang=js"
import style0 from "./game-pc-top.vue?vue&type=style&index=0&id=07c07cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c07cca",
  null
  
)

export default component.exports